import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

import { titleText, normalText } from 'features/Theme';

export default {
  headerTitle: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)};
    text-align: center;
  `,

  body: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
    color: ${theme.mui.palette.text.secondary};
    text-align: center;
    margin-bottom: ${theme.mui.spacing(1)}px;
  `,
};
